import { render, staticRenderFns } from "./AllLeaves.vue?vue&type=template&id=07d889c1&"
import script from "./AllLeaves.vue?vue&type=script&lang=ts&"
export * from "./AllLeaves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports